import styled from '@mui/system/styled';
import createStyles from '@mui/styles/createStyles';
import COLORS from '../../../../styles/Colors';

export const ButtonsContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  flexDirection: 'row',
});

export const styles = createStyles({
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: COLORS.WHITE,
    boxShadow: 24,
    p: 5,
    width: 450,
  },
  warningIcon: {
    width: 50,
    height: 50,
    marginBottom: 10,
  },
  image: {
    width: 80,
    maxWidth: '100%',
    verticalAlign: 'middle',
    display: 'inline-block',
    marginBottom: 10,
  },
});
